export const MAIN_COLOR = '#20C39E'
